import { h as s } from "vue";
const m = (e, h) => {
  const n = "http://www.w3.org/2000/svg", l = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path fill-rule="evenodd" d="M25.31 7.537a7.19 7.19 0 00-4.897-1.914 7.213 7.213 0 00-3.669 1.001c.708-2.417 2.94-4.188 5.582-4.188 2.966 0 5.42 2.23 5.775 5.1H25.31zm-.307 8.915l-8.167-8.167a5.782 5.782 0 013.577-1.227c1.553 0 3.012.604 4.11 1.701l.005.005a5.827 5.827 0 01.475 7.688zm-9.59-3.205l.316-3.557h.122l.316 3.557h-.755zm-.36 4.039l.231-2.603h1.011l.233 2.603h-1.475zm-.36 4.038l.232-2.603h1.73l.233 2.603h-2.195zm-.36 4.039l.232-2.603h2.45l.233 2.603h-2.915zm3.321 4.561h-3.727l.278-3.126h3.17l.28 3.126zM6.577 16.452a5.83 5.83 0 01.475-7.688l.003-.004a5.778 5.778 0 014.112-1.702 5.78 5.78 0 013.577 1.227l-8.167 8.167zM9.254 2.436c2.642 0 4.874 1.771 5.581 4.188a7.206 7.206 0 00-3.668-1.001 7.194 7.194 0 00-4.898 1.914H3.48a5.826 5.826 0 015.775-5.1zM22.326 1c-2.88 0-5.366 1.691-6.536 4.129C14.619 2.69 12.133 1 9.254 1 5.254 1 2 4.255 2 8.255c0 .397.321.717.718.717h2.34c-1.792 2.806-1.468 6.585.98 9.034a.718.718 0 001.016 0l7.128-7.128-.211 2.37h-.028a.71.71 0 00-.098 1.417l-.234 2.62h-.058a.718.718 0 00-.718.719c0 .372.287.667.649.704l-.234 2.635a.71.71 0 00-.623.699c0 .32.212.58.5.674l-.24 2.697a.715.715 0 00-.463.667c0 .259.144.476.35.602l-.29 3.262h-.451a.718.718 0 100 1.436h7.515a.718.718 0 100-1.436h-.45l-.291-3.261a.707.707 0 00.35-.603.715.715 0 00-.464-.667l-.24-2.697c.29-.092.5-.355.5-.674a.71.71 0 00-.622-.7l-.235-2.634a.71.71 0 00.648-.704.717.717 0 00-.718-.718h-.057l-.234-2.622a.709.709 0 00.62-.699.717.717 0 00-.717-.718h-.029l-.212-2.37 7.129 7.13a.717.717 0 001.015 0c2.45-2.45 2.775-6.228.98-9.035h2.342c.397 0 .718-.32.718-.717 0-4-3.255-7.255-7.255-7.255z"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const t = document.createElementNS(n, "title");
    t.textContent = e.title, l.appendChild(t);
  }
  const r = Array.from((l == null ? void 0 : l.attributes) ?? []).reduce((t, a) => ({
    ...t,
    [a.name]: a.value
  }));
  return s(
    "svg",
    {
      ...r,
      ...h.attrs,
      role: "img",
      innerHTML: l.innerHTML
    }
  );
};
export {
  m as default
};
//# sourceMappingURL=PalmIcon.Bv-PS4bP.js.map
